import request from '@/utils/request';

/**
 *  快手小说管理
 */
export function apis () {
    return {
        /** 分类管理 */
        //列表
        ApiCategoryList: params => {
            return request ({
                url: '/admin/rc/category/index',
                method: 'get',
                params,
            });
        },
        //下拉框
        ApiCategorySelect: params => {
            return request ({
                url: '/admin/rc/category/select',
                method: 'get',
                params,
            });
        },
        //详情
        ApiCategoryInfo: params => {
            return request ({
                url: '/admin/rc/category/info',
                method: 'get',
                params,
            });
        },
        //删除
        ApiCategoryDel: params => {
            return request ({
                url: '/admin/rc/category/del',
                method: 'get',
                params,
            });
        },
        //编辑
        ApiCategoryEdit: params => {
            return request ({
                url: '/admin/rc/category/edit',
                method: 'post',
                data: params,
            });
        },

        /** 信息管理 */
        //列表
        ApiInfoList: params => {
            return request ({
                url: '/admin/rc/feedback/index',
                method: 'get',
                params,
            });
        },
        //详情
        ApiInfosInfo: params => {
            return request ({
                url: '/admin/rc/feedback/info',
                method: 'get',
                params,
            });
        },
        //删除
        ApiInfoDel: params => {
            return request ({
                url: '/admin/rc/feedback/index',
                method: 'get',
                params,
            });
        },
        //接单
        ApiInfoJiedan: params => {
            return request ({
                url: '/admin/rc/feedback/jiedan',
                method: 'get',
                params,
            });
        },
        // 审核
        ApiInfoSh: params => {
            return request ({
                url: '/admin/rc/feedback/audit',
                method: 'post',
                data: params,
            });
        },
        ApiInfoDeal: params => {
            return request ({
                url: '/admin/rc/feedback/auditdo',
                method: 'post',
                data: params,
            });
        },
		
		// 获取统计
		gettot: params => {
            return request ({
                url: '/admin/rc/statistics/index',
                method: 'get',
                data: params,
            });
        },
    };
}
